import { useEffect, useRef, useState } from 'react';
import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import s from './styles/EventResult.module.scss';
import { Display } from '@/components/Display/Display';
import ResultLoading from './components/Loading/ResultLoading';
import GrtLoading from '@/components/Web/GrtLoading';
import titleImg from '@/assets/images/mobile/simulation/title_bg.png';
import useEventResult from '@/pages/hooks/CaseSImulation/useEventResult';
import ErrorPage from './components/ErrorPage';
const EventResult = (props) => {
    const { pageLoading, loading, goReport, reGenerateReport } = useEventResult({ ...props, side: 'mobile' });

    const { simulation } = props.store;
    let { eventResult = {}, pageProgress } = simulation;

    return (
        <>
            <div className={s['box-wrap']}>
                <Display show={pageLoading}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                        <GrtLoading />
                    </div>
                </Display>
                <Display show={!pageLoading}>
                    <>
                        <Display show={loading}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                                <ResultLoading text="正在生成事件结果，请稍后" />
                            </div>
                        </Display>
                        <Display show={!loading}>
                            <Display show={pageProgress === null}>
                                <ErrorPage onClick={reGenerateReport} />
                            </Display>
                            <Display show={pageProgress !== null}>
                                <div className={s['result-wrap']}>
                                    <div className={s['result-summary']}>
                                        <span className={s['summary-text']}> {`“${eventResult?.title}”`}</span>
                                        <img src={titleImg} alt="" />
                                    </div>
                                    <div className={s['result-item-wrap']}>
                                        <div className={s['result-item']}>
                                            <div className={s['title']}>
                                                【事件<span className={s['title-color']}>结果</span>】
                                            </div>
                                            <div className={s['content']}>{eventResult?.event_result_summary}</div>
                                        </div>

                                        <div className={s['result-item']}>
                                            <div className={s['title']}>
                                                【事件<span className={s['title-color']}>影响</span>】
                                            </div>
                                            <div className={s['content']}>
                                                {eventResult &&
                                                    eventResult?.event_impacts &&
                                                    eventResult?.event_impacts.map((item, index) => {
                                                        return (
                                                            <div className={s['item']} key={index}>
                                                                {item}
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={goReport} className={s['result-btn']}>
                                        查看复盘报告
                                    </div>
                                </div>
                            </Display>
                        </Display>
                    </>
                </Display>
            </div>
        </>
    );
};

export default withRouter(inject('store')(observer(EventResult)));
